import {GET_PAGE_NAV_START, GET_PAGE_NAV, HANDLE_PAGE_PAV_ERROR} from '../constants';
import {processPageNav} from '../../utils';

const initialState = {};

const pagenav = (state = initialState, action) => {
	switch (action.type) {
		case GET_PAGE_NAV_START:
			return {
				...state,
				[action.pageName]: {
					...state[action.pageName],
					data: null,
					isLoading: true,
				},
			};
		case GET_PAGE_NAV:
			return {
				...state,
				[action.pageName]: {
					...state[action.pageName],
					errorCode: undefined,
					data: processPageNav(action.pageNavData),
					isLoading: false,
				},
			};
		case HANDLE_PAGE_PAV_ERROR:
			return {
				[action.pageName]: {
					errorCode: action.errorCode,
					data: null,
					isLoading: false,
				},
			};
		default:
			return state;
	}
};

export default pagenav;
